import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Error boundary to catch and display JS crashes instead of blank screen
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('App crashed:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return React.createElement('div', {
        style: {
          background: '#1e1b4b', color: '#fff', padding: '40px 20px',
          minHeight: '100vh', fontFamily: 'sans-serif', fontSize: '14px'
        }
      },
        React.createElement('h2', { style: { color: '#f87171', marginBottom: '16px' } }, '⚠️ App Error'),
        React.createElement('p', { style: { marginBottom: '12px' } }, 'Please screenshot this and report it:'),
        React.createElement('pre', {
          style: {
            background: '#312e81', padding: '16px', borderRadius: '8px',
            whiteSpace: 'pre-wrap', wordBreak: 'break-all', fontSize: '12px', color: '#fcd34d'
          }
        }, String(this.state.error))
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  React.createElement(ErrorBoundary, null, React.createElement(App))
);
